// src/views/ContratosView.jsx
import React, { useEffect, useState } from "react";
import { getContratos, deleteContrato } from "../services/api";
import { Link } from "react-router-dom";

export default function ContratosView() {
  const [contratos, setContratos] = useState([]);

  const cargarContratos = async () => {
    try {
      const res = await getContratos();
      setContratos(res.data);
    } catch (err) {
      console.error("Error al cargar contratos:", err);
      alert("No se pudieron cargar los contratos");
    }
  };

  useEffect(() => {
    cargarContratos();
  }, []);

  const eliminar = async (id) => {
    if (!window.confirm("¿Eliminar contrato?")) return;

    try {
      await deleteContrato(id);
      cargarContratos();
    } catch (err) {
      console.error("Error al eliminar:", err);
      alert("Error al eliminar contrato");
    }
  };

  return (
    <div className="p-6">
      
      {/* TÍTULO */}
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-semibold text-gray-800">
          📡 Contratos Telefónicos
        </h2>

        <Link
          to="/contratos/nuevo"
          className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition"
        >
          + Nuevo Contrato
        </Link>
      </div>

      {/* TABLA RESPONSIVA */}
      <div className="overflow-x-auto shadow-lg rounded-xl border border-gray-200">
        <table className="min-w-[1200px] w-full text-sm">
          
          <thead className="bg-gray-100 text-gray-700 uppercase text-xs">
            <tr>
              {[
                "Ubicación",
                "Propietario",
                "Oficina",
                "Correo",
                "Teléfono",
                "Fecha Pago",
                "Total",
                "Compañía",
                "No. Cuenta",
                "Contraseña",
                "Acciones",
              ].map((col) => (
                <th key={col} className="px-4 py-3 text-left border-b">
                  {col}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {contratos.map((c) => (
              <tr
                key={c.id}
                className="border-b hover:bg-gray-50 transition cursor-pointer"
              >
                <td className="px-4 py-3">{c.ubicacion}</td>
                <td className="px-4 py-3">{c.propietario}</td>
                <td className="px-4 py-3">{c.oficina}</td>

                {/* Correo con ellipsis */}
                <td
                  className="px-4 py-3 max-w-[180px] truncate"
                  title={c.correo}
                >
                  {c.correo}
                </td>

                <td className="px-4 py-3">{c.telefono}</td>
                <td className="px-4 py-3">{c.fechaPago}</td>

                {/* MONTO COMO BADGE */}
                <td className="px-4 py-3">
                  <span className="px-2 py-1 bg-green-100 text-green-700 rounded-md font-medium">
                    ${c.totalPagar}
                  </span>
                </td>

                {/* COMPAÑÍA COMO BADGE */}
                <td className="px-4 py-3">
                  <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded-md">
                    {c.compania}
                  </span>
                </td>

                <td className="px-4 py-3">{c.numeroCuenta}</td>

                {/* PASSWORD con BLUR */}
                <td
                  className="px-4 py-3 blur-sm hover:blur-0 transition select-none"
                  title="Mantén el cursor para ver"
                >
                  {c.contrasena}
                </td>

                {/* ACCIONES */}
                <td className="px-4 py-3 flex gap-3">
                  <Link
                    to={`/contratos/editar/${c.id}`}
                    className="text-blue-600 hover:underline"
                  >
                    Editar
                  </Link>

                  <button
                    onClick={() => eliminar(c.id)}
                    className="text-red-600 hover:underline"
                  >
                    Eliminar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>
    </div>
  );
}
